import React from 'react'

import PropTypes from 'prop-types'

import SUIContext from '@s-ui/react-context'
import EmptyCase from '@adv-mt/mt-empty-case-default'

const EmptyCasePaymentAd = ({domain, i18n, price, adId, productId}) => {
  const config = domain.get('config')
  const IMAGE_URL = 'images/empty-case-info.svg'
  const formatedPrice = i18n.c(price)
  const {NUMBER_FREE_ADS} = config.get('search')
  const {CHECKOUT_URL} = config.get('page')
  const buttonText = i18n.t('EMPTY_CASE_PAYMENT_AD_BUTTON_TEXT', {
    price: formatedPrice
  })
  const buttonHref = CHECKOUT_URL.replace(':adId', adId).replace(':products', productId)
  const text = i18n.t('EMPTY_CASE_PAYMENT_AD_TEXT', {
    price: formatedPrice,
    freeAds: NUMBER_FREE_ADS
  })
  const title = i18n.t('EMPTY_CASE_PAYMENT_AD_TITLE')

  const props = {
    imageUrl: IMAGE_URL,
    title,
    text,
    buttonText,
    buttonHref
  }
  return <EmptyCase {...props} />
}

export default SUIContext.wrapper(EmptyCasePaymentAd, 'EmptyCasePaymentAd')

EmptyCasePaymentAd.displayName = 'EmptyCasePaymentAd'
EmptyCasePaymentAd.propTypes = {
  adId: PropTypes.number.isRequired,
  domain: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired,
  price: PropTypes.number.isRequired,
  productId: PropTypes.number.isRequired
}
